import { render, staticRenderFns } from "./RegistrationFilters.vue?vue&type=template&id=e44470a4"
import script from "./RegistrationFilters.vue?vue&type=script&lang=js"
export * from "./RegistrationFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports